import { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NewUserForm from "./NewUserForm";
import { getCookie } from "./CsrfToken";
import newUserModalClose from "../images/newUserModal_close.png";
import NewUserResponseContext from "../store/new-user-response-context";

import { API_URL } from "../config";

import classes from "./NewUserModal.module.css";

function NewUserModal(props) {
  //
  // Create a useNavigate instance.
  const navigate = useNavigate();

  // Set the NewUserResponseContext to a constant.
  const newUserResponseContext = useContext(NewUserResponseContext);

  // Get the question ID and option ID from newUserResponseContext.
  const questionId = newUserResponseContext.question;
  const optionId = newUserResponseContext.option;

  // Get the CSRF token from Django's csrf_token cookie.
  const csrf_token = getCookie("csrftoken");

  // Get the pathname of the page's current location (i.e. the URL in the
  //   browser's address bar).
  const currentLocation = useLocation();
  const clPath = currentLocation.pathname;

  // Define a path to navigate to upon submittal of the NewUserForm. If the
  //   current location is "/home/" or "/home", set our new value equal to the
  //   index "/". Otherwise set it to "/home/". We initially wanted to simply
  //   navigate to "/home/" upon submittal, but when the current location is
  //   "/home/" or "/home" and we are also navigating to "/home/", the page does
  //   not appear to refresh upon submittal. It simply stays on the new user
  //   page (though the new user record does get added to the database).
  var navigateTo;
  if ((clPath === "/home/") | (clPath === "/home")) {
    navigateTo = "/";
  } else {
    navigateTo = "/home/";
  }

  // Define a function to take the new user's ID and the question ID and option
  //   ID for the user's initial response and call the view that writes that
  //   response to the database.
  function writeInitialResponseHandler(uid, qid, oid) {
    //
    // Call the view to post the user's response to the database.
    fetch(
      (
        // "https://prodbe.polldock.com/api/newResponseNewUser/" +
        // "http://localhost:8000/api/newResponseNewUser/" +
        `${API_URL}/newResponseNewUser/${uid}/${qid}/${oid}/`
        // uid +
        // "/" +
        // qid +
        // "/" +
        // oid +
        // "/"
      ),
      {
        method: "POST",
        headers: { "X-CSRFToken": csrf_token },
      }
    ).then(
      (response) => {
        //
        // If the fetch() returns successfully, navigate to the question's
        //   results page. Otherwise, navigate to the generic error page. Also,
        //   before navigating, set question and option in the
        //   NewUserResponseContext both to NaN.
        const statusCode = response.status;
        newUserResponseContext.updateQuestionSelection(NaN);
        newUserResponseContext.updateOptionSelection(NaN);
        props.setShowNewUserModal(false);
        if (statusCode === 200) {
          navigate("/question-results/" + qid + "/");
        } else {
          navigate("/error/", { replace: true });
        }
      },
      () => {
        navigate("/error/", { replace: true });
      }
    );
  }

  // Define a function to receive the new user info obtained in the new uers
  //   form, create a new record in the User model containing that info,
  //   retrieve the user ID value corresponding to the new record, and store
  //   that new ID value in a cookie.
  function addNewUserHandler(userInfo) {
    //
    // Call the Django REST API view to post the new user record to the database
    //   and to retrieve the new user ID value that is created as a result.
    fetch(
      (
        // "https://prodbe.polldock.com/api/newUser/" +
        // "http://localhost:8000/api/newUser/" +
        `${API_URL}/newUser/${userInfo.sex}/${userInfo.decade}/${userInfo.location}/${userInfo.turnstileToken}/`
        // userInfo.sex +
        // "/" +
        // userInfo.decade +
        // "/" +
        // userInfo.location +
        // "/" +
        // userInfo.turnstileToken +
        // "/"
      ),
      {
        method: "GET",
        headers: {
          "X-CSRFToken": csrf_token,
        },
        credentials: "include",
      }
    )
      .then(
        (response) => {
          //
          // If the response comes back successfully, return the json() form of
          //   the response data. Otherwise, navigate to the generic error page.
          const statusCode = response.status;
          if (statusCode === 200) {
            // navigate(navigateTo, { replace: true });
            return response.json();
          } else {
            navigate("/error/", { replace: true });
            return null;
          }
        },
        () => {
          navigate("/error/", { replace: true });
        }
      )
      .then(
        (dataJson) => {
          //
          // If the data is populated, extract the new user's ID.
          if (dataJson.length > 0) {
            //
            // Extract the new user's ID.
            const userId = dataJson[0].id;

            // If questionId and optionId are both populated, call the function
            //   to post the user's initial response to the database, and then
            //   navigate to the main question list page. Otherwise, just
            //   navigate to the main question list page.
            if (questionId && optionId) {
              //
              // Call the function to post the user's initial response to the
              //   database.
              writeInitialResponseHandler(userId, questionId, optionId);
            } else {
              //
              // Navigate to the main question list page.
              navigate(navigateTo, { replace: true });
            }
          } else {
            navigate("/error/", { repalce: true });
          }
        },
        () => {
          navigate("/error/", { replace: true });
        }
      );
  }

  // Return components.
  return (
    <div className={classes.newUserModal_mainContainer}>
      <div className={classes.newUserModal_innerContainerWrapper}>
        <div className={classes.newUserModal_innerContainer}>
          <div className={classes.newUserModal_closeButtonDiv}>
            <div
              className={classes.newUserModal_closeButton}
              onClick={() => {
                props.setShowNewUserModal(false);
              }}
            >
              <img
                className={classes.newUserModal_closeButtonImg}
                src={newUserModalClose}
                alt={""}
              />
            </div>
          </div>
          <div className={classes.newUserModal_formDiv}>
            <NewUserForm onAddNewUser={addNewUserHandler} />
          </div>
          {/* <div className={classes.newUserModal_bottomBufferContainer}></div> */}
        </div>
      </div>
    </div >
  );
}

export default NewUserModal;
